import apiService, { ServiceType } from './api';

const core = () => apiService.getService(ServiceType.CORE);

export interface CustomerGuide {
  title: string;
  updatedAt: string;
  /** HTML fragment with its images inline. */
  html: string;
}

export async function getCustomerGuide(): Promise<CustomerGuide> {
  const { data } = await core().get<CustomerGuide>('/docs/customer-guide', { timeout: 60000 });
  return data;
}

/** The same guide as a Word file. Fetched with the session token, so it cannot be a plain link. */
export async function downloadCustomerGuide(): Promise<void> {
  const { data } = await core().get<Blob>('/docs/customer-guide/file', { responseType: 'blob', timeout: 60000 });
  const url = URL.createObjectURL(data);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'FORTUNA-CUSTOMER-GUIDE.docx';
  a.click();
  URL.revokeObjectURL(url);
}
